export default __webpack_public_path__ + "static/media/qq-group-qr.49faee7f.png";